module.exports = __webpack_public_path__ + "img/trademarkOwnerOthers.920da1fa.png";